import {BaseEvent} from "../BaseEvent";
import {MetricAlarmStatusDetail} from "../../models/notification/MetricAlarmStatusLite";

export class MetricAlarmStatusChangedDetailNtf extends BaseEvent {
  public static NAME = 'metricAlarmStatusChangedDetail';
  public value: MetricAlarmStatusDetail;

  constructor(status: MetricAlarmStatusDetail) {
    super(MetricAlarmStatusChangedDetailNtf.NAME);

    this.value = status;
  }
}
